var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 90,
    viewBox: "0 0 83 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80918e-05 30.7983V59.1601C-0.00429595 62.0842 0.762985 64.9578 2.22453 67.4912C3.68607 70.0247 5.79023 72.1285 8.32494 73.5905L32.9251 87.7714C35.4562 89.2314 38.3273 90 41.25 90C44.1727 90 47.0438 89.2314 49.5749 87.7714L74.175 73.5905C76.7098 72.1285 78.8139 70.0247 80.2755 67.4912C81.737 64.9578 82.5043 62.0842 82.5 59.1601V30.7983C82.497 27.8812 81.7262 25.0163 80.2651 22.4907C78.8039 19.9652 76.7036 17.868 74.175 16.4095L49.5749 2.2286C47.0438 0.768617 44.1727 0 41.25 0C38.3273 0 35.4562 0.768617 32.9251 2.2286L8.32494 16.6174C5.82662 18.0581 3.74582 20.1226 2.28644 22.6086C0.827065 25.0945 0.0391874 27.9166 1.80918e-05 30.7983Z",
    fill: "#FE6E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0463 55.0011C64.4819 57.5006 62.6798 60.6251 59.8125 60.6251H22.488C19.6152 60.6251 17.8215 57.4958 19.2543 55.0011L37.9167 22.4989C39.3531 19.9982 42.9505 20.0027 44.3843 22.4989L63.0463 55.0011ZM41.1505 48.2813C39.1746 48.2813 37.5727 49.8903 37.5727 51.8751C37.5727 53.8598 39.1746 55.4688 41.1505 55.4688C43.1264 55.4688 44.7283 53.8598 44.7283 51.8751C44.7283 49.8903 43.1264 48.2813 41.1505 48.2813ZM37.7537 35.3637L38.3307 45.9887C38.3577 46.4858 38.7669 46.8751 39.2626 46.8751H43.0384C43.5341 46.8751 43.9433 46.4858 43.9703 45.9887L44.5473 35.3637C44.5765 34.8266 44.1508 34.3751 43.6154 34.3751H38.6856C38.1501 34.3751 37.7245 34.8266 37.7537 35.3637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErro);
export default __webpack_public_path__ + "static/media/icon_erro.feba350a975d08f55d2c0d08849b7279.svg";
export { ForwardRef as ReactComponent };